import { createFileRoute } from '@tanstack/react-router'
import { FabricOverviewPage } from '@bloo-team/product-fabric'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): Datafabric ·
 * Overview, the pipeline health worklist (docs/fabric-overview.md). No search
 * params — the page has no window and its checks link out pre-filtered.
 */
function OverviewRoute() {
  const { clusterId, scopeId } = Route.useParams()
  return <FabricOverviewPage clusterId={clusterId} scopeId={scopeId} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/fabric/overview')({
  component: OverviewRoute,
})
